// colors
import {orange} from '@drivesally/sally-ui/lib/libs/colors';

const escapeRegExp = (text) => text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

// Operates on already-formatted HTML (see formatChatMessage.lib.chaya.js) — only
// wraps matches found in text segments, never inside a tag, so it can't corrupt
// markup even though the input is HTML rather than plain text.
const highlightChatMessage = (html, term) => {
  if (!term || !term.trim()) return html;

  const pattern = new RegExp(`(${escapeRegExp(term.trim())})`, 'gi');

  return html
    .split(/(<[^>]+>)/g)
    .map((part) =>
      part.startsWith('<')
        ? part
        : part.replace(
            pattern,
            `<mark style="background:${orange};padding:0;">$1</mark>`
          )
    )
    .join('');
};

export default highlightChatMessage;
